import { render, staticRenderFns } from "./issue-view.vue?vue&type=template&id=579d9b3a&scoped=true"
import script from "./issue-view.vue?vue&type=script&lang=js"
export * from "./issue-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579d9b3a",
  null
  
)

export default component.exports